import { Routes, Route, useParams } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import { Navigate } from 'react-router';
import { ApplicantProfileIdentityContainer } from '../components/applicant-profile-identity.container';
import { ApplicantProfileIdentityEditContainer } from '../components/applicant-profile-identity-edit.container';

export const ApplicantProfileIdentity: React.FC = () => {
  const params = useParams();

  return (
    <div>
      <Helmet>
        <title>Applicant - Identity Details</title>
      </Helmet>
      <Routes>
        <Route index element={<Navigate to="view" replace />} />
        <Route path="view/*" element={<ApplicantProfileIdentityContainer applicantId={params.applicantId || ''} />} />
        <Route path="edit/*" element={<ApplicantProfileIdentityEditContainer applicantId={params.applicantId || ''} />} />
      </Routes>
    </div>
  );
};
